const API_URL:any = `${window.location.protocol}//${window.location.host}/workbench/results`;

export default class ApiService {
	private _initialized: boolean = false;

	// Insure that there's a single instance of FilterService shared by all components
	static _instance: ApiService;

	static getInstance(): ApiService {
		return ApiService._instance || new ApiService();
	}

	get initialized() {
		return this._initialized;
	}

	constructor() {
		if (!ApiService._instance) {
			ApiService._instance = this;
		}

		return ApiService._instance;
	}

	static fetchWorkbenchProjectData(baseUrl: string, data: any) {
		let url:any = new URL(`${window.location.protocol}//${window.location.host}${baseUrl}/results`);
		Object.keys(data).forEach(key => url.searchParams.append(key, data[key]));
		
		return fetch(url).then((response) => {
			return response.json().then((data) => {
				return data;
			}).catch((err) => {
				console.log(err);
			})
		});
	}
}
